var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowLeft = function SvgArrowLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1533.6 1055.3"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m20.9 578 456.4 456.4c27.8 27.8 73 27.8 100.8 0 27.8-27.9 27.8-73 0-100.8L243.5 599h1218.8c39.4-.1 71.3-32 71.3-71.4s-31.9-71.3-71.3-71.3H243.5l334.6-334.6c27.8-27.9 27.8-73 0-100.8A71.2 71.2 0 0 0 527.7 0c-18.2 0-36.5 7-50.4 20.9L20.9 477.3C-7 505-7 550.2 20.9 578"
  })));
};
export default SvgArrowLeft;